module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ShareSendBlessView.js"));
	}, "ShareSendBlessView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ShareSendBlessView!./src/pages/Promote/PromoteHome/ShareSendBless/ShareSendBlessView.js
// module id = 2052
// module chunks = 367